var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5301 12.53L8.53005 19.53C8.46105 19.599 8.37813 19.6539 8.28713 19.6919C8.19613 19.7299 8.09802 19.75 8.00002 19.75C7.90202 19.75 7.80491 19.7299 7.71291 19.6919C7.62091 19.6539 7.53899 19.599 7.46999 19.53L0.469994 12.53C0.176994 12.237 0.176994 11.762 0.469994 11.469C0.762994 11.176 1.23803 11.176 1.53103 11.469L7.251 17.189V1C7.251 0.586 7.587 0.25 8.001 0.25C8.415 0.25 8.751 0.586 8.751 1V17.189L14.471 11.469C14.764 11.176 15.239 11.176 15.532 11.469C15.825 11.762 15.8231 12.237 15.5301 12.53Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.bf6c9382ca476ae18a85d5ba11c0fa68.svg";